import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Container, Row, Col, Card, CardBody, CardTitle, CardText, Button
} from 'reactstrap';
import { XOctagon } from 'lucide-react';

const MerchantDeleted = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const reason = state?.data?.reason || "No reason provided.";

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#fff0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
        }}>
            <Container>
                <Row className="justify-content-center">
                    <Col md="8" lg="6">
                        <Card className="shadow-lg border-0 rounded-4 p-4" style={{ backgroundColor: '#fff' }}>
                            <CardBody className="text-center">
                                <div style={{
                                    backgroundColor: '#ffe5e5',
                                    borderRadius: '50%',
                                    width: '90px',
                                    height: '90px',
                                    margin: '0 auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    animation: 'fadeZoom 0.4s ease-out',
                                }}>
                                    <XOctagon size={48} color="#d10000" />
                                </div>

                                <CardTitle tag="h2" className="mt-4 text-danger fw-bold">
                                    Account Permanently Deleted
                                </CardTitle>

                                <CardText className="mt-3 text-dark">
                                    Your merchant account has been permanently removed from our system.
                                    <br />
                                    <strong>This action is irreversible and your data cannot be recovered.</strong>
                                </CardText>

                                <CardText className="mt-4 text-muted" style={{ fontSize: '1.1rem' }}>
                                    <strong>Reason:</strong> {reason}
                                </CardText>

                                <div className="mt-5 d-flex justify-content-center gap-3">
                                    <Button
                                        color="dark"
                                        outline
                                        className="px-4 py-2 rounded-pill"
                                        onClick={() => navigate('/')}
                                    >
                                        Back to Home
                                    </Button>

                                    <Button
                                        color="danger"
                                        className="px-4 py-2 rounded-pill"
                                        onClick={() => window.location.href = 'mailto:support@fitfind.com'}
                                    >
                                        Contact Support
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <style>{`
        @keyframes fadeZoom {
          0% { transform: scale(0.8); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
        </div>
    );
};

export default MerchantDeleted;
